import { Typography, type TypographyProps } from "@mui/material";
import { ONBOARDING_INVITATION_HEADING_SX } from "../features/organisations/onboarding/onboardingDesign.js";

/** The centred page heading of an invitation screen. */
export const InvitationHeading = ({
  sx,
  ...props
}: Omit<TypographyProps<"h1">, "variant" | "component">) => (
  <Typography
    {...props}
    variant="h1"
    sx={[ONBOARDING_INVITATION_HEADING_SX, ...(Array.isArray(sx) ? sx : [sx])]}
  />
);
